import styled from 'styled-components';

const StatusBoxStyled = styled.div`
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 16px;
  box-shadow: 0px 9px 38px -6px rgba(0, 0, 0, 0.14);
`;

const NotPaidContainerStyled = styled.div`
  padding: 16px;
  gap: 16px;
  display: grid;

  @media (min-width: 769px) {
    gap: ${({ isMultiAccount, status, pathname }) =>
      isMultiAccount &&
      (status === 'warning' || status === 'created') &&
      pathname === '/home'
        ? '0px'
        : '16px'};
  }
`;

const PaymentContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: space-between;

    ${({ isMultiAccount, status }) =>
      isMultiAccount &&
      (status === 'created' || status === 'warning') &&
      `
        align-items: center;
      `};
  }
`;

const PaymentInfoStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ status }) =>
    status === 'expired' || status === 'not_paid'
      ? 'center'
      : ' space-between'};
  font-size: 16px;
  line-height: 18px;
  color: #381451;
  p {
    ${({ status }) =>
      status === 'expired' || status === 'not_paid'
        ? 'text-align: center'
        : 'text-align: left'};
  }
  @media (min-width: 769px) {
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
    flex-grow: 1;
    margin: 0 16px 0 0;
    p {
      text-align: left;
    }
  }
`;

const PaymentButtonContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  > button {
    max-width: 248px;
    white-space: nowrap;
  }

  @media (min-width: 769px) {
    ${({ isMultiAccount, status }) =>
      isMultiAccount &&
      (status === 'created' || status === 'warning') &&
      `
        flex-direction: column;
      `};
  }
`;

const BottomInfoStyled = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 16px;
  font-size: 14px;
  line-height: 18px;
  color: #7c6c8a;
  svg {
    flex-shrink: 0;
    margin-right: 9px;
  }
  a {
    color: #e92070;
  }
  @media (min-width: 769px) {
    padding: 16px 16px 0;
    border-top: #ccc4d2 1px solid;
  }
`;

const PaidContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${({ status, pathname }) =>
    status === 'paid' && pathname === '/mis-boletas'
      ? '16px 24px 0'
      : '16px 24px'};
  gap: 16px;
  @media (min-width: 769px) {
    flex-direction: row;
    gap: ${({ status }) => (status === 'paid' ? '0px' : '24px')};
    padding: 16px 24px;
  }
`;

const PaidMessageStyled = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  color: #2d1441;
  margin: auto;
  justify-content: center;

  svg {
    flex-shrink: 0;
    margin-right: 16px;
    width: 48px;
    height: 48px;
  }

  @media (min-width: 769px) {
    font-size: 20px;
    line-height: 23px;
  }
`;

const PATMessageStyled = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  color: #2d1441;
  align-items: start;

  svg {
    flex-shrink: 0;
    margin-right: 8px;
    width: 48px;
    height: 48px;
  }

  p {
    padding-top: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #494c66;
    line-height: 20px;
  }
`;

const PatContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  font-size: 14px;
  line-height: 16px;
  color: #21102e;

  @media (min-width: 769px) {
    align-items: flex-start;
    flex-direction: row;
  }

  svg {
    flex-shrink: 0;
    margin-top: 16px;
    margin-right: 16px;
    align-items: center;
  }
`;

const PaidButtonCotainerStyled = styled.div`
  width: 100%;
  max-width: 248px;

  > button {
    width: 100%;
  }

  @media (min-width: 769px) {
    width: auto;
    padding: 0;
    gap: 8px;
    > button {
      width: 100%;
      min-width: 148px;
    }
  }
`;

const PatButtonContainerStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  font-size: 14px;
  margin: 16px 0px;

  @media (min-width: 769px) {
    align-items: center;
    text-align: center;
    flex-direction: column;
    margin: auto;
  }
  a {
    position: static;
    width: 155px;
    height: 20px;
    left: 57px;
    top: 52px;

    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    display: flex;
    align-items: center;
    text-decoration-line: underline;

    /* Acento */

    color: #e92070;

    /* Inside auto layout */

    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 8px 0px;
  }
`;

const TextContainerStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  font-size: 14px;
  margin: 16px 0px;

  @media (min-width: 769px) {
    max-width: 419px;
    align-items: flex-start;
    text-align: left;
  }

  h3 {
    padding-bottom: 5px;
    font-size: 18px;
    line-height: 21px;
    font-weight: 600;
  }
`;

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  .MuiButtonBase-root:nth-child(2) {
    width: 100%;
  }
  @media (min-width: 769px) {
    display: grid;
    grid-template-columns: ${({ accountSelector }) =>
      accountSelector ? 'minmax(130px, 260px) auto' : '1fr'};
    .MuiButtonBase-root:nth-child(2) {
      min-width: 120px;
    }
  }
`;

const AmountPayContainerStyled = styled.div`
  & > p:first-child {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }

  & > p:nth-child(2) {
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
    color: #381451;
  }
`;

const DueDateContainerStyled = styled.div`
  & > p:first-child {
    text-align: right;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }

  & > p:nth-child(2) {
    font-size: 20px;
    line-height: 32px;
    font-weight: 600;
  }
`;

const MoreServicesStyled = styled.div`
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  padding: 16px;
  display: block;
  & > p {
    font-weight: 400;
    color: #494c66;
  }

  & > a {
    font-weight: 500;
    color: #4d008c;
    @media (min-width: 769px) {
      padding-left: 8px;
    }
  }

  @media (min-width: 769px) {
    padding: 16px;
    display: flex;
    border-top: 1px solid #c9cfd7;
    justify-content: center;

    ${({ isMultiAccount }) =>
      isMultiAccount &&
      `
      grid-column: -1 / 1;
  `};
  }
`;

const ErrorContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 16px 24px;
  gap: 16px;
  && {
    button {
      max-height: 30px;
      text-transform: none;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      align-self: center;
      padding: 6px 20px;
    }
  }

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    && {
      button {
        padding: 6px 12px;
      }
    }
  }
`;

const IconAndInfoContainerStyled = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  svg {
    height: 40px;
    width: 40px;
  }
  & > div:first-child {
    align-self: flex-start;
  }
`;

const ErrorInfoContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  h1 {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: #494c66;
  }

  span {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #494c66;
  }
`;

const ErrorMonoContainerStyled = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 24px;
  justify-content: center;
  padding: 32px 16px 32px 16px;

  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e6ea;

  @media (min-width: 769px) {
    padding: 40px 16px 40px 16px;
  }
`;

export {
  StatusBoxStyled,
  NotPaidContainerStyled,
  PaymentContainerStyled,
  PaymentInfoStyled,
  BottomInfoStyled,
  PaymentButtonContainerStyled,
  PaidContainerStyled,
  PaidMessageStyled,
  PatContainerStyled,
  PaidButtonCotainerStyled,
  PatButtonContainerStyled,
  TextContainerStyled,
  ContainerStyled,
  AmountPayContainerStyled,
  DueDateContainerStyled,
  MoreServicesStyled,
  PATMessageStyled,
  ErrorContainerStyled,
  IconAndInfoContainerStyled,
  ErrorInfoContainerStyled,
  ErrorMonoContainerStyled,
};
